webpackJsonp([18],{

/***/ 275:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {
/** Import frontoffice_app */

__webpack_require__(5);

var _location_handler = _interopRequireDefault(__webpack_require__(7));

var _cart = _interopRequireDefault(__webpack_require__(11));

var _const = _interopRequireDefault(__webpack_require__(39));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * @class CartHandler
 */
var CartHandler =
/*#__PURE__*/
function () {
  /**
   * @constructor
   */
  function CartHandler() {
    _classCallCheck(this, CartHandler);

    this._renderCartList();

    _cart.default.addRemoveCallback(this._renderCartList);
  }
  /**
   * @private
   */


  _createClass(CartHandler, [{
    key: "_renderCartList",
    value: function _renderCartList() {
      var that = this,
          total = 0,
          cartTotal = 0,
          deliveryTotal = 0,
          cart = _cart.default.getCartItems(),
          cartList = '',
          imgPrefix = this.constructor._getImgPrefix();

      $.each(cart, function (k, v) {
        var displayPrice = parseInt(v.price);

        if (_const.default.HIDDEN_DELIVERY === 'true') {
          displayPrice = displayPrice + parseInt(v.delivery_price);
        }

        cartList += '<tr class="cart-item" data-cartitem="' + v.slug + '|' + v.name + '|' + v.price + '|' + v.delivery_price + '|' + v.img + '|' + v.stock + '">' + '<td class="product-thumbnail" data-title="Slika"><a href="#"><img class="cart-image" src="' + imgPrefix + v.img + '" alt="img"/></a></td>' + '<td class="product-name" data-title="Naziv proizvoda"><a href="' + imgPrefix + 'index.php/product/' + v.slug + '/details' + '">' + v.name + '</a></td>' + '<td class="product-price" data-title="Cena"><span class="price">' + displayPrice + ' RSD</span></td>' + '<td class="product-quantity" data-title="Kolicina"><div class="quantity">' + '<a href="#" class="sign minus item-list-quantity-minus"><i class="fa fa-angle-left"></i></a>' + '<input type="text" value="' + v.quantity + '" title="Qty" class="input-text qty text item-list-quantity" size="' + v.quantity + '">' + '<a href="#" class="sign plus item-list-quantity-plus"><i class="fa fa-angle-right"></i></a>' + '</div></td>' + '<td class="product-subtotal" data-title="Ukupno"><span class="price item-list-price-total">' + displayPrice * v.quantity + ' RSD</span></td>' + '<td class="product-remove"> <a href="#" class="remove"><i class="fa fa-times item-list-remove"></i></a></td>' + '</tr>';
        cartTotal = cartTotal + v.price * v.quantity;
        deliveryTotal = deliveryTotal + parseInt(v.delivery_price) * v.quantity;
      });
      total = parseInt(cartTotal);

      if (_const.default.HIDDEN_DELIVERY === 'true') {
        total = parseInt(cartTotal) + parseInt(deliveryTotal);
      }

      $('#cart-item-list-table').empty().html(cartList);
      $('#item-list-total').empty().html(total + ' RSD');
      var retailTotal = 0,
          calculateDeliveryTotal = 0,
          sum = 0;

      if (cart.length > 0) {
        retailTotal = parseInt(cartTotal);
        calculateDeliveryTotal = parseInt(deliveryTotal);
        sum = retailTotal + calculateDeliveryTotal;
        $('#item-list-retail-total').val(retailTotal);

        if (_const.default.HIDDEN_DELIVERY === 'true') {
          $('#item-list-delivery').val(calculateDeliveryTotal);
          $('#item-list-delivery-total').val(sum);
        } else {
          calculateDeliveryTotal = calculateDeliveryTotal + ' RSD';
          sum = sum + ' RSD';
          $('#item-list-delivery').html(calculateDeliveryTotal);
          $('#item-list-delivery-total').html(sum);
        }

        _cart.default.adjustDeliveryTotal(retailTotal, parseInt(deliveryTotal), retailTotal + parseInt(deliveryTotal));

        $('#cart-continue').removeAttr('style');
        $('#cart-order').removeAttr('style');
      } else {
        $('#item-list-retail-total').val(retailTotal);

        if (_const.default.HIDDEN_DELIVERY === 'true') {
          $('#item-list-delivery').val(calculateDeliveryTotal);
          $('#item-list-delivery-total').val(sum);
        } else {
          calculateDeliveryTotal = calculateDeliveryTotal + ' RSD';
          sum = sum + ' RSD';
          $('#item-list-delivery').html(calculateDeliveryTotal);
          $('#item-list-delivery-total').html(sum);
        }

        _cart.default.adjustDeliveryTotal(0, 0, 0);

        $('#cart-continue').attr('style', 'color: #FFF; cursor: not-allowed; opacity: 0.5; text-decoration: none;');
        $('#cart-order').attr('style', 'color: currentColor; cursor: not-allowed; opacity: 0.5; text-decoration: none;');
      } // if (cart.length > 0)
      // {
      //     AjaxHandler.post('delivery-price', cart).then((response) =>
      //     {
      //         let
      //             delivery = parseInt(response.deliveryPrice),
      //             total = delivery + cartTotal;
      //
      //         $('#item-list-delivery').html(delivery + ' RSD');
      //         $('#item-list-delivery-total').html(total + ' RSD');
      //         Cart.adjustDeliveryTotal(cartTotal, delivery, total);
      //
      //         $('#cart-continue').removeAttr('style');
      //         $('#cart-order').removeAttr('style');
      //     });
      // } else {
      //     $('#item-list-delivery').html('0 RSD');
      //     $('#item-list-delivery-total').html('0 RSD');
      //     Cart.adjustDeliveryTotal(0, 0, 0);
      //
      //     $('#cart-continue').attr('style', 'color: #FFF; cursor: not-allowed; opacity: 0.5; text-decoration: none;');
      //     $('#cart-order').attr('style', 'color: currentColor; cursor: not-allowed; opacity: 0.5; text-decoration: none;');
      // }


      $('.item-list-quantity-minus').unbind('click').on('click', function (e) {
        var row = that.constructor._findFormRow(e.target),
            cartItem = row.data('cartitem'),
            quantity = row.find('.item-list-quantity').val(),
            itemObj = that._prepareObject(cartItem);

        quantity = parseInt(quantity) > 0 ? parseInt(quantity) - 1 : 0;

        _cart.default.adjustQuantity(itemObj.slug + '', quantity);

        that._renderCartList();
      });
      $('.item-list-quantity-plus').unbind('click').on('click', function (e) {
        var row = that.constructor._findFormRow(e.target),
            cartItem = row.data('cartitem'),
            quantity = row.find('.item-list-quantity').val(),
            itemObj = that._prepareObject(cartItem);

        quantity = parseInt(quantity) + 1;

        _cart.default.adjustQuantity(itemObj.slug + '', quantity);

        that._renderCartList();
      });
      $('.item-list-quantity').unbind('blur').on('blur', function (e) {
        var row = that.constructor._findFormRow(e.target),
            cartItem = row.data('cartitem'),
            quantity = row.find('.item-list-quantity').val(),
            itemObj = that._prepareObject(cartItem);

        quantity = quantity ? parseInt(quantity) : 0;

        if (quantity > parseInt(itemObj.stock)) {
          quantity = parseInt(itemObj.stock);
        }

        _cart.default.adjustQuantity(itemObj.slug + '', quantity);

        that._renderCartList();
      });
      $('.item-list-remove').unbind('click').on('click', function (e) {
        var row = that.constructor._findFormRow(e.target),
            cartItem = row.data('cartitem'),
            itemObj = that._prepareObject(cartItem);

        _cart.default.removeFromCartList(itemObj.slug + '');

        that._renderCartList();
      });
    }
    /**
     * @param item
     * @return {*}
     * @private
     */

  }, {
    key: "_prepareObject",
    value: function _prepareObject(item) {
      var itemObj = {},
          itemProps = ['slug', 'name', 'price', 'delivery_price', 'img', 'stock', 'quantity'],
          itemData = item.split('|');
      $.each(itemProps, function (k, v) {
        var data = itemData[k];

        if (v === 'quantity') {
          data = 1;
        }

        itemObj[v] = data;
      });
      return itemObj;
    }
    /**
     * @param element
     * @returns {jQuery|HTMLElement}
     * @private
     */

  }], [{
    key: "_findFormRow",
    value: function _findFormRow(element) {
      var elem = element;

      while ($(elem).prop("tagName") !== 'TR') {
        elem = elem.parentNode;
      }

      return $(elem);
    }
    /**
     * @return {string}
     * @private
     */

  }, {
    key: "_getImgPrefix",
    value: function _getImgPrefix() {
      var base = _location_handler.default.getBaseUrl(),
          index = 'index.php';

      return base.substr(0, base.length - index.length);
    }
  }]);

  return CartHandler;
}();
/** Start CartHandler */


$(document).ready(function () {
  new CartHandler();
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ })

},[275]);


// WEBPACK FOOTER //
// frontoffice_cart.js